import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import PayList from "@/components/PayList/PayList.vue";
import PayListOld from "@/components/PayListOld/PayListOld.vue";
import FooterPage from "@/components/FooterPage/FooterPage.vue";
import { gameDetail } from "@/api/api";
import { ref, onMounted, onDeactivated, onActivated } from "vue";
import { useRouter } from "vue-router";
import { showDialog } from "vant";
export default {
  components: {
    PayList,
    FooterPage,
    PayListOld
  },
  setup() {
    const isOld = ref(""); //判断是否开启购物车功能
    onDeactivated(() => {
      isOld.value = "";
    });
    const gameId = ref("");
    const route = useRouter();
    const getListDetails = () => {
      isOld.value = "";
      gameDetail(gameId.value, "").then(res => {
        if (res.data.list && res.data.list.length > 0) {
          let list = res.data.list;
          list.forEach(item => {
            if (item.game_id == gameId.value) {
              if (item.version_open == 1 || item.version_open == "1") {
                isOld.value = "open";
              } else isOld.value = "close";
            }
          });
        } else {
          showDialog({
            title: "维护信息",
            message: "亲爱的玩家，系统维护中，请您耐心等待。"
          }).then(() => {
            route.push({
              path: `/home`
            });
          });
        }
      });
    };
    onMounted(() => {
      gameId.value = route.currentRoute.value.query.gameId;
      getListDetails();
    });
    onActivated(() => {
      gameId.value = route.currentRoute.value.query.gameId;
      getListDetails();
    });
    return {
      gameId,
      getListDetails,
      isOld
    };
  }
};